import { IncomingMessage, ServerResponse } from 'http'
import { NextPageContext } from 'next'
import { isClient } from '~/utils/envChecks'
import { parseCookieString } from '../utils'

interface ServerNextContext extends NextPageContext {
  req: IncomingMessage
  res: ServerResponse
}

export const isServerPageContext = (context: NextPageContext): context is ServerNextContext =>
  'req' in context && 'res' in context && !isClient()

export const getCookiesForClientOrServer = (context: NextPageContext) => {
  if (isClient()) {
    // client-side: Get cookies from document.cookie
    return parseCookieString(document.cookie)
  }
  // server-side: Get cookies from the request headers
  return parseCookieString(context.req?.headers.cookie)
}

// For current whitelabel set up
export const getHostForClientOrServer = (context: NextPageContext) => {
  if (isClient()) {
    // client-side: Get host from document.location
    return window?.location?.host
  }
  // server-side: Get host from the request headers
  return context.req?.headers.host
}
